import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=204f8aa1&scoped=true"
import script from "./Component.vue?vue&type=script&lang=js"
export * from "./Component.vue?vue&type=script&lang=js"
import style0 from "./Component.vue?vue&type=style&index=0&id=204f8aa1&prod&lang=scss&scoped=true"
import style1 from "./Component.vue?vue&type=style&index=1&id=204f8aa1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f8aa1",
  null
  
)

export default component.exports